import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';

const style = {
  cursor: 'move',
};

function MovingCards({ id, isProductArchived, rowItem, onSelectCheckBox, editState, handleEdit, activeInactiveClicked, deleteRow, index, moveRow, isName }) {
  const ref = useRef(null);
  const { t } = useTranslation('common');
  const {
    Users: { userGroupsCardList, logInRights },
    UserDetails: { isSupplierLoggedIn },
  } = useSelector((reducer) => reducer);

  const { CheckActionPermission } = useComponent();

  const OperationalAddEditAccess = CheckActionPermission(logInRights, 'criticalPath', 'operational', 'addEdit');
  const OperationalDeleteAccess = CheckActionPermission(logInRights, 'criticalPath', 'operational', 'delete');

  const [{ handlerId }, drop] = useDrop({
    accept: 'card',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveRow(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });
  const [{ isDragging }, drag] = useDrag({
    type: 'card',
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0.5 : 1;
  drag(drop(ref));

  return (
    <tr key={`row_${id}_${index}`} style={{ ...style, opacity }} data-handler-id={handlerId} ref={ref}>
      {!isSupplierLoggedIn && (OperationalAddEditAccess || OperationalDeleteAccess) && (
        <td>
          <div className="checkbox-label no-label margin-auto">
            <input
              onChange={(e) => {
                onSelectCheckBox(e, rowItem?._id);
              }}
              name={`checks_${rowItem?._id}`}
              id={`checks_${rowItem?._id}`}
              type="checkbox"
              disabled={isProductArchived || isName}
              checked={editState?.selectedRows?.includes(rowItem?._id)}
            />
            <label htmlFor={`checks_${rowItem?._id}`} className="chklabel" />
          </div>
        </td>
      )}
      <td style={{ wordBreak: 'break-word' }}>{rowItem?.name}</td>
      <td>{userGroupsCardList?.find((element) => element?._id === rowItem?.assignee)?.name}</td>
      {!isSupplierLoggedIn && (OperationalAddEditAccess || OperationalDeleteAccess) && (
        <td>
          {OperationalAddEditAccess && (
            <button
              type="button"
              title={t('OPERATIONAL_CP.MOVING_CARD.EDIT')}
              className="btn px-1"
              onClick={() => handleEdit(index)}
              disabled={isProductArchived}
            >
              <span className="icon-edit" />
            </button>
          )}
          {OperationalAddEditAccess && (
            <button type="button" className="btn px-1 mr-0" id={rowItem?._id} disabled={isProductArchived}>
              <span className="icon-expand" />
            </button>
          )}
          {OperationalAddEditAccess && (
            <button
              type="button"
              className="btn px-1 mr-0"
              title={rowItem.isActive ? t('OPERATIONAL_CP.MOVING_CARD.ACTIVE') : t('OPERATIONAL_CP.MOVING_CARD.INACTIVE')}
              onClick={() => activeInactiveClicked(index)}
              id={rowItem._id}
              disabled={isProductArchived}
            >
              <span className={rowItem.isActive ? 'icon-active' : 'icon-inactive'} />
            </button>
          )}
          {OperationalDeleteAccess && (
            <button
              type="button"
              className="btn px-1"
              title={t('OPERATIONAL_CP.MOVING_CARD.ACTIVE')}
              onClick={() => deleteRow(rowItem?._id)}
              disabled={isProductArchived}
            >
              <span className="icon-delete" />
            </button>
          )}
        </td>
      )}
    </tr>
  );
}

export default MovingCards;
